import httpClient from "../http/http-client";
import { ISpendBasedConversion } from './spend-based-conversion.model';

export default class SpendBasedConversionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllSpendBasedConversions(queryString?: string): Promise<ISpendBasedConversion[]> {
    return this.http.get(`spend-based-conversion${queryString ? `?${queryString}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getSpendBasedConversionsForConversionSource(conversionSourceId: string, year?: string, closestYear?: boolean, active?: boolean, years?: number[]): Promise<ISpendBasedConversion[]> {
    const params: string[] = []
    if (year) params.push(`year=${encodeURIComponent(year)}`)
    if (Array.isArray(years) && years.length > 0) params.push(`years=${encodeURIComponent(years.join(','))}`)
    if (closestYear) params.push('closestYear=true')
    if (active) params.push('active=true')
    const query = params.length ? `?${params.join('&')}` : ''
    return this.http.get(`spend-based-conversion/${conversionSourceId}/conversions${query}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getSpendBasedConversionsForConversionSourceIncludingResultYears(conversionSourceId: string, year?: string, closestYear?: boolean, active?: boolean, years?: number[]): Promise<{ rows: ISpendBasedConversion[], resultYears: number[] }> {
    const params: string[] = []
    if (year) params.push(`year=${encodeURIComponent(year)}`)
    if (Array.isArray(years) && years.length > 0) params.push(`years=${encodeURIComponent(years.join(','))}`)
    if (closestYear) params.push('closestYear=true')
    if (active) params.push('active=true')
    const query = params.length ? `?${params.join('&')}` : ''
    return this.http.get(`spend-based-conversion/${conversionSourceId}/conversions${query}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getSpendBasedConversionsForConversionSourceWithPagination(conversionSourceId: string, year: string, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: ISpendBasedConversion[] }> {
    return this.http.get(`spend-based-conversion/${conversionSourceId}/conversions?year=${year}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}